import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { BsCacheService } from '@brightside-web/desktop/data-access/core-services';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export const redirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const cache = inject(BsCacheService);

  return from(cache.getItem('redirectUrl')).pipe(
    map(url => {
      if (url && url !== '/home') {
        cache.removeItem('redirectUrl');
        return router.parseUrl(url);
      }
      return true;
    })
  );
};
